import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { map, get, sortBy, filter, includes } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import FormSection from "../../Common/FormSection";
import MultipleFormSection from "./MultipleFormSection";
import DetailsContainer from "../../Common/DetailsContainer";

import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";

import { LANGUAGES, OCR, LPR } from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  sectionCol: {
    padding: "12px 24px 0px",
    minWidth: "248px",
    maxWidth: "308px",
  },
};

const VehicleForm = (props) => {
  const {
    classes,
    profileType,
    section,
    data,
    lov,
    handleChange,
    validForm,
    errors,
    language,
    existingRecords,
    profileAttributes,
  } = props;

  const isValid = (id) => {
    if (getAttributeValue(data, 44) && props.bulkOverrideEnabled && data["sys_tag_id"]  && getAttributeValue(data, 50) && getAttributeValue(data, 18) && getAttributeValue(data, 89)) {
      validForm["ocrOrLpr"] = true
      validForm[44] = true
      validForm[18] = true
      validForm[89] = true
      validForm['tag'] = true
      validForm.form = true
    } else {
      validForm.form = false
    }
    
    if (validForm && validForm[id]) {
      return true;
    }
    return false;
  };

  const renderDebugTable = (title, data) => {
    return (
      <Grid item xs={4} style={{ padding: "0px 6px 0px 0px" }}>
        <Box className="text-center bold-500">{title}</Box>
        <Box
          style={{
            maxHeight: "200px",
            overflowY: "auto",
            overflowX: "hidden",
            margin: 0,
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: "0.750em" }}>
                  {I18n.get("profiles_dacId")}
                </TableCell>
                <TableCell style={{ fontSize: "0.750em" }}>
                  {I18n.get("profiles_detectionId")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>{item.detection_event_group_id}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Grid>
    );
  };

  if (section === "main") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    
    return (
      <>
        <Grid container style={{ marginTop: "-14px" }}>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingTop: "29px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 18)]}
                setFormValue={handleChange}
                title2={getAttributeName(18)}
                id={18}
                options={{ required: true, redBorder: !isValid(18) }}
              />
              <FormSection
                formValue={[
                  getAttributeValue(
                    data,
                    profileType === 2 ? 42 : profileType === 3 ? 53 : 54
                  ),
                ]}
                setFormValue={handleChange}
                title2={getAttributeName(
                  profileType === 2 ? 42 : profileType === 3 ? 53 : 54
                )}
                id={profileType === 2 ? 42 : profileType === 3 ? 53 : 54}
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid(
                    profileType === 2 ? 42 : profileType === 3 ? 53 : 54
                  ),
                  options:
                    lov[profileType === 2 ? 42 : profileType === 3 ? 53 : 54] &&
                    lov[
                      profileType === 2 ? 42 : profileType === 3 ? 53 : 54
                    ].map((t) => ({
                      id: t.id,
                      name: t["name_" + language],
                    })),
                }}
              />
              <FormSection
                formValue={[data.sys_tag_id]}
                setFormValue={handleChange}
                title="tag"
                id="sys_tag_id"
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid("sys_tag_id"),
                  comboBox: true,
                  options:
                    lov.tag &&
                    lov.tag.map((t) => ({
                      id: t.id,
                      name: t["name_" + language],
                    })),
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingTop: "29px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 89)]}
                setFormValue={handleChange}
                title2={getAttributeName(89)}
                id={89}
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid(89),
                  comboBox: true,
                  options: map(
                    sortBy(get(lov, [89]), (t) => t[`name_${language}`]),
                    (t) => ({
                      id: t.id,
                      name: t[`name_${language}`],
                    })
                  ),
                }}
              />
              <FormSection
                formValue={[getAttributeValue(data, 45)]}
                setFormValue={handleChange}
                title2={getAttributeName(45)}
                id={45}
              />
              <FormSection
                formValue={[getAttributeValue(data, 46)]}
                setFormValue={handleChange}
                title2={getAttributeName(46)}
                id={46}
              />
            </Grid>
          </Grid>
          <Grid item xs>
            <Grid container direction="column">
              <Grid
                item
                style={{
                  color: colors.black54,
                  fontStyle: "italic",
                  margin: "0px 0px 12px 24px",
                  fontSize: "1em",
                }}
              >
                {isValid("ocrOrLpr") && (
                  <img
                    src={images.successIcon}
                    width="14px"
                    alt="success"
                    style={{ marginRight: "5px" }}
                  />
                )}
                {I18n.get("profiles_licensePlateOrOcr")}
              </Grid>
              <Grid item>
                <Grid container>
                  <Grid
                    item
                    xs
                    className={classes.sectionCol}
                    style={{
                      paddingTop: "0px",
                      maxWidth: "208px",
                      minWidth: "208px",
                    }}
                  >
                    <FormSection
                      id={44}
                      formValue={[getAttributeValue(data, 44)]}
                      setFormValue={handleChange}
                      title="licensePlate"
                      title2={getAttributeName(44)}
                      options={{
                        required: true,
                        errorMsg: errors[44],
                        redBorder:
                          (getAttributeValue(data, 44) && !isValid(44)) ||
                          (!getAttributeValue(data, 44) &&
                            !isValid("ocrOrLpr")),
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs
                    className={classes.sectionCol}
                    style={{
                      paddingTop: "0px",
                      maxWidth: "unset",
                      minWidth: "unset",
                    }}
                  >
                    <MultipleFormSection
                      id={50}
                      typeId={135}
                      title2={getAttributeName(50)}
                      data={getAttributeValues(data, 50)}
                      setFormValue={handleChange}
                      lov={lov}
                      language={language}
                      errorMsg={errors[50]}
                      required={true}
                      checkbox={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {(existingRecords[OCR].count !== 0 ||
                existingRecords[LPR].count !== 0) && (
                <Grid
                  item
                  style={{
                    margin: "0px 24px",
                    backgroundColor: colors.orange10,
                    padding: "12px",
                  }}
                >
                  <Box className="text-87 bold-500">
                    {I18n.get("profiles_historicRecordsTitle")}
                  </Box>
                  <ul className="text-87">
                    {existingRecords[LPR].count > 0 && (
                      <li>
                        {existingRecords[LPR].count +
                          " " +
                          I18n.get("profiles_lprHistoricRecords")}
                      </li>
                    )}
                    {existingRecords[OCR].count > 0 && (
                      <li>
                        {existingRecords[OCR].count +
                          " " +
                          I18n.get("profiles_ocrHistoricRecords1") +
                          " " +
                          getAttributeValues(data, 50).filter(
                            (ocr) => ocr.mandatory_match
                          ).length +
                          " " +
                          I18n.get("profiles_ocrHistoricRecords2")}
                      </li>
                    )}
                  </ul>
                  <Grid container alignItems="center">
                    <Grid item>
                      <Checkbox
                        color="primary"
                        checked={props.bulkOverrideEnabled}
                        onChange={() =>
                          props.setBulkOverrideEnabled(
                            !props.bulkOverrideEnabled
                          )
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      className="bold-500"
                      style={{ color: colors.errorRed }}
                    >
                      {I18n.get("profiles_warningHistoricRecords1") +
                        " " +
                        existingRecords.total.count +
                        " " +
                        I18n.get("profiles_warningHistoricRecords2")}
                    </Grid>
                  </Grid>
                  {props.powerUserModeEnabled && (
                    <DetailsContainer title="Debug">
                      <Grid container className="text-italic">
                        {renderDebugTable(
                          `LPR (${existingRecords[LPR].count})`,
                          existingRecords[LPR].records
                        )}
                        {renderDebugTable(
                          `OCR (${existingRecords[OCR].count})`,
                          existingRecords[OCR].records
                        )}
                        {renderDebugTable(
                          `LPR + OCR (${existingRecords.total.count})`,
                          existingRecords.total.records
                        )}
                      </Grid>
                    </DetailsContainer>
                  )}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => {
            return [51,52].includes(attr.id)?null:<Grid
              item
              key={attr.id}
              xs={3}
              style={{
                paddingBottom: "0px",
                padding: "10px 24px 0px 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
            >
              <Grid container direction="column">
                <FormSection
                  formValue={[getAttributeValue(data, attr.id)]}
                  setFormValue={handleChange}
                  attribute={attr}
                  id={attr.id}
                  type={
                    includes(["radiobutton", "lov(picker)"], attr.data_type)
                      ? "select"
                      : attr.data_type === "boolean"
                      ? "boolean"
                      : "input"
                  }
                  options={{
                    redBorder: attr.required && !isValid(attr.id),
                    comboBox: attr.id === 89,
                    options: includes(
                      ["radiobutton", "lov(picker)"],
                      attr.data_type
                    )
                      ? map(
                          sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                          (t) => ({
                            id: t.id,
                            name: t[`name_${language}`],
                          })
                        )
                      : null,
                  }}
                />
              </Grid>
            </Grid>
  })}
        </Grid>
      </>
    );
  }

  if (section === "secondary") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <Grid container>
          {/* <Grid item xs={3} className={classes.sectionCol}>
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 51)]}
                setFormValue={handleChange}
                title2={getAttributeName(51)}
                id={51}
                options={{ type: "number" }}
              />
              <FormSection
                formValue={[getAttributeValue(data, 52)]}
                setFormValue={handleChange}
                title2={getAttributeName(52)}
                id={52}
                options={{ type: "number" }}
              />
            </Grid>
          </Grid> */}
          <Grid item xs={3} className={classes.sectionCol}>
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 47)]}
                setFormValue={handleChange}
                title2={getAttributeName(47)}
                id={47}
                type="select"
                options={{
                  options: Array(new Date().getFullYear() - 1989)
                    .fill()
                    .map((v, i) => ({
                      id: new Date().getFullYear() - i,
                      name: (new Date().getFullYear() - i).toString(),
                    })),
                }}
              />
              <FormSection
                formValue={[
                  getAttributeValue(data, 104) === true
                    ? 1
                    : getAttributeValue(data, 104) === false
                    ? 2
                    : "",
                ]}
                setFormValue={handleChange}
                title2={getAttributeName(104)}
                id={104}
                type="select"
                options={{
                  type: "bool",
                  options: [
                    { id: 1, name: I18n.get("site_yes") },
                    { id: 2, name: I18n.get("site_no") },
                  ],
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
            className={classes.sectionCol}
            style={{ maxWidth: "627px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 19)]}
                setFormValue={handleChange}
                title2={getAttributeName(19)}
                id={19}
                options={{ multiline: true, height: "118px" }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => {
            return attr.id === 135 ? null : <Grid
              item
              key={attr.id}
              xs={3}
              style={{
                paddingBottom: "0px",
                padding: "10px 24px 0px 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
            >
              <Grid container direction="column">
                <FormSection
                  formValue={[getAttributeValue(data, attr.id)]}
                  setFormValue={handleChange}
                  attribute={attr}
                  id={attr.id}
                  type={
                    includes(["radiobutton", "lov(picker)"], attr.data_type)
                      ? "select"
                      : attr.data_type === "boolean"
                      ? "boolean"
                      : "input"
                  }
                  options={{
                    redBorder: attr.required && !isValid(attr.id),
                    comboBox: attr.id === 89,
                    options: includes(
                      ["radiobutton", "lov(picker)"],
                      attr.data_type
                    )
                      ? map(
                          sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                          (t) => ({
                            id: t.id,
                            name: t[`name_${language}`],
                          })
                        )
                      : null,
                  }}
                />
              </Grid>
            </Grid>
          })}
        </Grid>
      </>
    );
  }

  return null;
};

VehicleForm.propTypes = {
  profileType: PropTypes.oneOf([2, 3, 4]).isRequired,
  section: PropTypes.oneOf(["main", "secondary"]).isRequired,
  data: PropTypes.object.isRequired,
  lov: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  validForm: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
  setBulkOverride: PropTypes.func,
  isUpdate: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    powerUserModeEnabled: state.common.powerUserModeEnabled,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(VehicleForm));
